<template>
  <div>
    <div v-if="isLoading" class="d-flex flex-center m-y-6">
      <loading-indicator :size="48"/>
    </div>
    <div class="PROLIST" v-if="profiles && !isLoading">
      <div class="h2 text-bold text-center m-t-3">Review a Pro</div>
      <p class="text-bold text-center p-x-4 p-t-3">Choose a pro you want to review</p>
      <p class="text-md text-center c-gray70 p-x-4 p-b-3">
        (You can only post one review at a time)
      </p>
      <router-link
          v-for="({
            id,
            service_provider: { business_name, logo },
          }, index) in woProfiles"
          :key="id"
          :to="getProfileUrl(index)"
          :event="getReviewed(id) ? '' : 'click'"
          :disabled="getReviewed(id)"
          class="PRO-PANEL">
        <dashboard-panel class="p-1" v-if="prosToShow(id)">
          <div class="d-flex ai-center jc-between">
            <div class="d-flex ai-center">
              <pro-avatar :image="logo" :size="64" class="m-r-2" />
              {{ business_name }}
            </div>
            <span v-if="getReviewed(id)" class="text-medium text-normal c-gray70">Reviewed</span>
            <vk-icon v-else name="chevronright" class="c-depot" />
          </div>
        </dashboard-panel>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getReview } from '@homeservices/api-kit/workorder/reviews';
import reviewParams from '@/mixins/review-params';
import publicProfile from '@/mixins/public-profile';
import workOrder from '@/mixins/work-order';
import ProAvatar from '@/components/ProAvatar';
import DashboardPanel from '@/components/DashboardPanel';

export default {
  name: 'pro-list',
  components: {
    ProAvatar,
    DashboardPanel,
  },
  mixins: [
    reviewParams,
    workOrder,
    publicProfile,
  ],
  data () {
    return {
      reviewedProfiles: null,
      isLoading: true,
      prosTohide: null,
    };
  },
  computed: {
    ...mapState('propublicprofile', [
      'profiles',
    ]),
    woProfiles () {
      return Object.values(this.profiles);
    },
  },
  async mounted () {
    setTimeout(() => {
      this.setReviewedProfiles(this.jobId);
    }, 1000);
  },
  methods: {
    getProfileUrl (index) {
      return {
        name: 'consumer::reviews::new',
        query: {
          ...this.$route.query,
          [this.$options.REVIEWS_QUERY_PARAMS.PROFILE_ID]:
            this.woProfiles[index].service_provider.identifier,
        },
      };
    },
    getReviewed (id) {
      return this.reviewedProfiles && this.reviewedProfiles[id];
    },
    prosToShow (id) {
      return !(this.prosTohide && this.prosTohide[id]);
    },
    async setReviewedProfiles (jobId) {
      this.isLoading = true;
      try {
        await this.fetchWorkOrder({ jobId, includePublicProfiles: true });
      } catch (error) {
        console.error(error); // eslint-disable-line no-console
      }

      const { data: { results } } = await getReview({
        order_hashes: this.workOrder.order_hash,
      });

      const reviewProviderIds = results.map(r => (r.service_provider_id));

      this.prosTohide = await this.woProfiles.reduce((acc, cur) => {
        const matchStatus = this.workOrder.matches.find(
          match => match.service_provider_id === cur.service_provider.id
        );
        acc[cur.id] = matchStatus.match_status === this.$options.MATCH_STATUSES.UNREPLIED
        || matchStatus.match_status === this.$options.MATCH_STATUSES.UNRESPONSIVE
        || matchStatus.match_status === this.$options.MATCH_STATUSES.REJECTED;
        return acc;
      }, {});
      this.reviewedProfiles = await this.woProfiles.reduce((acc, cur) => {
        acc[cur.id] = reviewProviderIds.indexOf(cur.service_provider.id) > -1;
        return acc;
      }, {});
      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";
  .PROLIST {
    max-width: 700px;
    margin: auto;
  }
  .PRO-PANEL {
    @include link-black;
    @include hover(text-decoration, none, none);
    font-weight: 600;
    color: $color-gray80;

    &[disabled] {
      cursor: default;
    }
  }
</style>
